import { Chat, ChatRef, WithNativeHTMLProps } from "@kalyzee/kast-web-sdk/web-components";
import React, { ForwardedRef, useEffect, useState } from "react";

// import { ReactComponent as IconChatDisabled } from "../../../assets/icons/noChat.svg";
import "./Chat.css";
import styles from "./Chat.module.css";
import { ReactIcons } from "@kalyzee/kalyzee-ui";

export interface SlaveChatProps extends WithNativeHTMLProps<HTMLDivElement> {
  chatRef?: React.RefObject<ChatRef>;
  className?: string;
  style?: React.CSSProperties;
}

export interface SecondaryScreenChatRef {}

const SlaveChat = ({ chatRef, className, style, nativeProps }: SlaveChatProps) => {
  const [isDisabled, setDisabled] = useState<boolean>(false);

  // ---------------------------------------------------------------------- //
  // ---------------------------  EFFECTS ----------------------------- //
  // ---------------------------------------------------------------------- //

  useEffect(() => {
    if (!chatRef) return;
    const disableListener = chatRef.current?.addEventListener("disable", () => setDisabled(true));
    const enableListener = chatRef.current?.addEventListener("enable", () => setDisabled(false));
    setDisabled(chatRef.current?.isDisabled() ?? false);
    return () => {
      enableListener?.flush();
      disableListener?.flush();
    };
  }, [chatRef]);

  // ---------------------------------------------------------------------- //
  // ---------------------------  RENDER ----------------------------- //
  // ---------------------------------------------------------------------- //

  const classes = ["dashboard_chat", styles.container];
  if (className) classes.push(className);
  return (
    <div {...(nativeProps ?? {})} className={classes.join(" ")} style={style}>
      {/*<HeaderChat
          conversationsLength={0}
          tagStyle={{display: 'none'}}
          isChatActive={!isDisabled}
          disabledActiveChatButton
          disabledClearChatButton
          cx={styles.header}
        ></HeaderChat>*/}
      <div className={styles.content}>
        <Chat
          className={styles.chat}
          ref={chatRef}
          disableLoadMoreMessages
          messageParameters={{
            disableBubbleInteraction: true,
            disableDeletion: true,
            disableReaction: true,
            onAvatarClick: (msg) => {
              return false;
            },
          }}
          hideAvatarMaxRepetition={0}
        />

        {isDisabled && (
          <div className={styles.overlayDisabled}>
            <ReactIcons.ChatBubble width={40} height={40} />
          </div>
        )}
      </div>
    </div>
  );
};

export default SlaveChat;
